import { useContext } from 'react';
import { DataContext } from '@components/DataProvider';

export default function usePageContext() {
  const { location, pageContext } = useContext(DataContext);
  return { location, ...pageContext };
}
